var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play-button-wrapper"},[_c('button',{class:{ 'audio-pause' : _vm.playing },on:{"click":_vm.togglePlayback}},[_vm._v(_vm._s(_vm.playing ? "テスト再生を停止" : "音楽をテスト再生"))])])}
var staticRenderFns = []

export { render, staticRenderFns }